// Calls onResult(data, jwt) once, when Cardinal's 3-D Secure step has finished.
//
// Songbird is meant to report the end of the bank's check as the
// "payments.validated" event. Cardinal's newer result page, served from
// cas.client.cardinaltrusted.com, posts its result to this window as a message
// ({"CardinalJWT": "..."}) that the Songbird we load does not pass on, so the
// event never came and the payment stopped behind a white box (October 2026).
// Both are listened for here; whichever arrives first is used, and only once.
const CARDINAL_ORIGIN = /^https:\/\/([a-z0-9-]+\.)*(cardinalcommerce\.com|cardinaltrusted\.com)$/i;

export function cardinalJwtFromMessage(event) {
  if (!event || !CARDINAL_ORIGIN.test(event.origin || "")) return null;
  let data = event.data;
  if (typeof data === "string") {
    try {
      data = JSON.parse(data);
    } catch (e) {
      return null;
    }
  }
  return data && typeof data.CardinalJWT === "string" && data.CardinalJWT ? data.CardinalJWT : null;
}

export function onCardinalResult(onResult) {
  let done = false;
  const finish = (data, jwt) => {
    if (done || !jwt) return;
    done = true;
    window.removeEventListener("message", listener);
    onResult(data, jwt);
  };
  const listener = (event) => {
    const jwt = cardinalJwtFromMessage(event);
    if (jwt) finish(null, jwt);
  };
  window.addEventListener("message", listener);
  if (window.Cardinal && typeof window.Cardinal.off === "function") {
    window.Cardinal.off("payments.validated");
  }
  window.Cardinal.on("payments.validated", (data, jwt) => finish(data, jwt));
}
